const duplicateTranslationKey = (key: string): string => key;

export const translationUploadData_sv_part2 = {
  scheduledFor: "Schemalagd för",
  chunkDisabled: "Inaktiverad",
  chunkPartiallyDisabled: "Delvis inaktiverad",
  chunkEnable: "Aktivera del",
  chunkDisable: "Inaktivera del",
  chunkEnabledLabel: "Aktiv i kunskapsbasen",
  chunkEnabledHint: "Inaktiverade delar finns kvar i listan men hämtas inte av botar.",
  chunkEnabledMessage: "Del aktiverad",
  chunkDisabledMessage: "Del inaktiverad",
  chunkStatusUpdateError: "Kunde inte uppdatera delens status",
  chunkScheduleSection: "Synlighetsschema",
  chunkScheduleHint:
    "Valfritt schema för när den här delen ska vara aktiv i kunskapsbasen (t.ex. 17:00–07:00).",
  chunkSchedulePill: "Schemalagd synlighet",
  chunkScheduleNone: "Alltid aktiv",
  chunkScheduleFixed: "Mellan datum",
  chunkScheduleWeekly: "Veckovisa timmar",
  bannerScheduleNone: "Alltid (inget schema)",
  bannerScheduleFixed: "Mellan datum",
  bannerScheduleWeekly: "Veckovisa timmar",
  bannerScheduleStarts: "Start (valfritt)",
  bannerScheduleEnds: "Slut (valfritt)",
  bannerScheduleTz: "Tidszon",
  bannerScheduleWeeklyDays: "Dagar",
  bannerScheduleWeeklyStart: "Starttid",
  bannerScheduleWeeklyEnd: "Sluttid",
  bannerScheduleWeeklyHint:
    "Om sluttiden är tidigare på klockan än starttiden sträcker sig fönstret över midnatt (t.ex. 17:00–07:00).",
  bannerScheduleFixedHint: "Lagras som absoluta tider. Rensa ett fält för att lämna det öppet.",
  bannerScheduleEndIn3Days: "Slut om 3 dagar",
  bannerWeekday0: "Sön",
  bannerWeekday1: "Mån",
  bannerWeekday2: "Tis",
  bannerWeekday3: "Ons",
  bannerWeekday4: "Tor",
  bannerWeekday5: "Fre",
  bannerWeekday6: "Lör",
  missingInfoTickets: "Saknad information",
  missingInfoTicketsTitle: "Ärenden med saknad information",
  missingInfoTicketsDescription: "AI-drivna förslag på innehåll att ladda upp till din chatbot",
  generateTickets: "Generera ärenden",
  generating: "Genererar...",
  selectLanguageOption: "Välj språk",
  selectTicketTranslationLanguage: "Välj språk för ärendeöversättning",
  translateTickets: "Översätt",
  translatingTickets: "Översätter...",
  analyzingConversations: "Analyserar konversationer och genererar ärenden...",
  generatedTickets: "Genererade {count} nya ärenden!",
  noNewTicketsGenerated: "Inga nya ärenden genererades",
  howItWorks: "Så här fungerar det:",
  howItWorksDescription:
    'Varje måndag analyserar AI:n automatiskt dina senaste konversationer märkta med "saknad information" och skapar ärenden för de vanligaste frågorna. Du kan också manuellt starta ärendegenerering när som helst.',
  pending: "Väntar",
  uploaded: "Uppladdad",
  rejected: "Avvisad",
  expired: "Utgången",
  noChatbotSelected: "Ingen chatbot vald",
  selectChatbotMessage: "Välj en chatbot från rullgardinsmenyn ovan för att visa ärenden.",
  noTicketsFound: "Inga ärenden hittades",
  generateTicketsPrompt: "Generera ärenden för att få AI-drivna förslag på saknad information",
  noTicketsWithStatus: "Inga ärenden med den här statusen",
  priority: "Prioritet",
  deleteTicket: "Ta bort ärende",
  uploadInfo: "Ladda upp info",
  reject: "Avvisa",
  uploadInformation: "Ladda upp information",
  titleLabel: "Titel",
  titlePlaceholder: "Titel för den här informationen",
  informationLabel: "Information",
  informationPlaceholder: "Ange informationen som besvarar den här frågan...",
  questionLabel: "Fråga:",
  autoDeleteOptional: "Automatisk borttagning (valfritt)",
  selectAutoDeleteDate: "Välj datum och tid",
  clearDate: "Rensa datum",
  autoDeleteTooltip: "Innehållet tas automatiskt bort vid den valda tidpunkten",
  selectIndexFirst: "Välj en kunskapsbas först",
  ticketRejected: "Ärende avvisat",
  ticketDeleted: "Ärende borttaget",
  infoUploadedSuccess: "Information uppladdad!",
  uploadSuccessSummaryLabel: "Sammanfattning",
  uploadSuccessOk: "OK",
  enterInfoToUpload: "Ange informationen som ska laddas upp",
  failedToFetchTickets: "Det gick inte att hämta ärenden",
  failedToGenerateTickets: "Det gick inte att generera ärenden",
  failedToRejectTicket: "Det gick inte att avvisa ärendet",
  failedToDeleteTicket: "Det gick inte att ta bort ärendet",
  failedToTranslateTickets: "Det gick inte att översätta ärenden",
  failedToUploadInfo: "Det gick inte att ladda upp informationen",
  basedOnConversations: "Baserat på {count} konversation(er)",
  viewConversation: "Visa konversation",
  relatedConversations: "Relaterade konversationer",
  noRelatedConversations: "Inga relaterade konversationer",
  more: "fler",
  aiHelp: "AI-hjälp",
  aiHelpComingSoon: "AI-hjälpfunktionalitet kommer snart!",
  aiHelpDescription:
    'Klicka på "Kör analys" för att få AI-drivna insikter om dina informationsdelar',
  aiAnalysis: "AI-analys",
  runAnalysis: "Kör analys",
  analyzing: "Analyserar...",
  analyzingYourData: "Analyserar dina data...",
  potentialDuplicates: "Möjliga dubbletter",
  recommendations: "Rekommendationer",
  totalItems: "Totalt antal poster",
  duplicates: "Dubbletter",
  backToUpload: "Tillbaka till uppladdningsdata",
  markAsHandled: "Markera som hanterad",
  markAsNotHandled: "Markera som ohanterad",
  showHandled: "Visa hanterade",
  searchPlaceholder: "Sök i dina informationsdelar...",
  resultsFound: "resultat hittades",
  clearHighlightedItems: "Rensa markerade poster",
  showMore: "Visa mer",
  showLess: "Visa mindre",
  confidence: "Konfidens",
  show: "Visa",
  loading: "Laddar...",
  suggestMerge: "Föreslå sammanslagning",
  mergeSuggestion: "Sammanslagningsförslag",
};
